import { render, staticRenderFns } from "./CommunityCommentEditModal.vue?vue&type=template&id=2da72868&"
import script from "./CommunityCommentEditModal.vue?vue&type=script&lang=js&"
export * from "./CommunityCommentEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports